import { proxy, useSnapshot } from "valtio"

export type FlyingCarpetPage =
  | "none"
  | "account"
  | "account/tickets"
  | "account/details"
  | "account/change-password"
  | "account/login"
  | "account/create"
  | "account/forgot-password"
  | "account/reset-password"
  | "cart"

function createFlyingCarpetStore() {
  const store = proxy({
    isOpen: false,
    page: "none" as FlyingCarpetPage,
    open(page: FlyingCarpetPage) {
      store.isOpen = true
      store.page = page
    },
    close() {
      store.isOpen = false
    },
  })
  return store
}

export const flyingCarpetStore = createFlyingCarpetStore()

type FlyingCarpetStore = typeof flyingCarpetStore

export function useFlyingCarpet() {
  return useSnapshot(flyingCarpetStore) as FlyingCarpetStore
}
